export default vin => {
    const vinRegex = /[a-zA-Z0-9]{17}$/;
    const isValid = vinRegex.test(vin);
    return isValid;
};
